// EmailJS Configuration — values loaded from .env (restart dev server after changing .env)
import emailjs from '@emailjs/browser';

export const emailjsConfig = {
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  recipientEmail: process.env.REACT_APP_RECIPIENT_EMAIL,
};

const missingKeys = Object.entries({
  REACT_APP_EMAILJS_PUBLIC_KEY: emailjsConfig.publicKey,
  REACT_APP_EMAILJS_SERVICE_ID: emailjsConfig.serviceId,
  REACT_APP_EMAILJS_TEMPLATE_ID: emailjsConfig.templateId,
  REACT_APP_RECIPIENT_EMAIL: emailjsConfig.recipientEmail,
})
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingKeys.length > 0) {
  console.warn(
    `EmailJS not fully configured. Missing in .env: ${missingKeys.join(', ')}. Restart the dev server after updating .env.`
  );
} else if (process.env.NODE_ENV === 'development') {
  console.info('EmailJS configured:', {
    serviceId: emailjsConfig.serviceId,
    templateId: emailjsConfig.templateId,
    recipientEmail: emailjsConfig.recipientEmail,
  });
}

if (emailjsConfig.publicKey) {
  emailjs.init(emailjsConfig.publicKey);
}

export default emailjsConfig;
